import React from 'react';
import { Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * Company Logo component
 * Displays the company logo from the cached data URL or direct URL
 * Falls back to company name if no logo is available
 */
const CompanyLogo = ({ width = 300, height = 150, showName = false }) => {
  const { logoDataUrl, logoUrl, deviceInfo } = useAuth();
  const companyName = deviceInfo?.company_name || 'Company';

  if (logoDataUrl) {
    return (
      <img
        src={logoDataUrl}
        alt={`${companyName} Logo`}
        style={{
          maxWidth: `${width}px`,
          maxHeight: `${height}px`,
          width: 'auto',
          height: 'auto'
        }}
      />
    );
  } else if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={`${companyName} Logo`}
        style={{
          maxWidth: `${width}px`,
          maxHeight: `${height}px`,
          width: 'auto',
          height: 'auto'
        }}
      />
    );
  } else if (showName) {
    return (
      <Typography variant="h5" fontWeight="bold">
        {companyName}
      </Typography>
    );
  }

  return null;
};

export default CompanyLogo;